export var query = "query getConfig {\n    clientConfig {\n      language\n      layoutDirection\n      storeCurrency\n    }\n    experiments {\n      name\n      value\n    }\n}";
//# sourceMappingURL=getConfig.graphql.js.map